// La navegacion de la Consola en un solo lugar (D26): siete modulos como maximo en el riel, y cada modulo con sus
// secciones en el panel de al lado. Lo usan el riel, el panel, la barra de secciones del celular y el buscador (Ctrl K).
// Cada seccion dice que permiso exige (D99, lib/permisos.ts; sin permiso la ven todos) y que modulo del plan; un
// modulo sin secciones visibles no aparece.
import type { IconName } from '../lib/icons';

export type Contador = 'hoy' | 'llamadas' | 'tareas' | 'correos' | 'casos';
export type Seccion = {
  ruta: string;
  nombre: string;
  icono: IconName;
  permiso?: string;
  modulo?: string;
  contador?: Contador;
  // Otras direcciones que pertenecen a esta seccion (fichas).
  tambien?: string[];
  // Titulo del grupo en el panel del modulo (D96: Ventas en Comercial, Proyectos, Soporte y Licencias 3CX).
  grupo?: string;
};
export type ModuloId = 'inicio' | 'bandeja' | 'clientes' | 'ventas' | 'marketing' | 'reportes' | 'admin';
export type Modulo = { id: ModuloId; nombre: string; icono: IconName; secciones: Seccion[]; abajo?: boolean };

export const MODULOS: Modulo[] = [
  {
    id: 'inicio',
    nombre: 'Inicio',
    icono: 'home',
    secciones: [
      { ruta: '/hoy', nombre: 'Hoy', icono: 'home', contador: 'hoy' },
      { ruta: '/agenda', nombre: 'Agenda', icono: 'calendar' },
    ],
  },
  {
    id: 'bandeja',
    nombre: 'Bandeja',
    icono: 'inbox',
    secciones: [
      { ruta: '/bandeja/correos', nombre: 'Correos', icono: 'mail', contador: 'correos' },
      { ruta: '/bandeja/casos', nombre: 'Casos', icono: 'inbox', contador: 'casos' },
      { ruta: '/llamadas', nombre: 'Llamadas', icono: 'phone', contador: 'llamadas' },
      { ruta: '/tareas', nombre: 'Tareas', icono: 'task', contador: 'tareas' },
      { ruta: '/bandeja/conocimiento', nombre: 'Conocimiento', icono: 'book' },
      { ruta: '/bandeja/accesos', nombre: 'Accesos', icono: 'lock' },
    ],
  },
  {
    id: 'clientes',
    nombre: 'Clientes',
    icono: 'users',
    secciones: [
      { ruta: '/contactos', nombre: 'Contactos', icono: 'user', tambien: ['/personas/', '/object/person/'] },
      { ruta: '/empresas', nombre: 'Empresas', icono: 'building', tambien: ['/object/company/'] },
    ],
  },
  {
    id: 'ventas',
    nombre: 'Ventas',
    icono: 'trend',
    secciones: [
      { ruta: '/ventas', nombre: 'Resumen', icono: 'home' },
      { ruta: '/oportunidades', nombre: 'Oportunidades', icono: 'kanban', grupo: 'Comercial', permiso: 'oportunidades.ver' },
      { ruta: '/proyectos', nombre: 'Proyectos', icono: 'task', grupo: 'Proyectos' },
      { ruta: '/horas', nombre: 'Mis horas', icono: 'clock', grupo: 'Proyectos' },
      { ruta: '/horas-equipo', nombre: 'Horas del equipo', icono: 'users', grupo: 'Proyectos', permiso: 'horas.equipo' },
      { ruta: '/bolsas', nombre: 'Bolsas de soporte', icono: 'clock', grupo: 'Soporte' },
      { ruta: '/licencias-3cx', nombre: 'Por vencer', icono: 'key', grupo: 'Licencias 3CX', permiso: 'licencias3cx.ver' },
      { ruta: '/licencias-3cx/renovaciones', nombre: 'Renovaciones', icono: 'refresh', grupo: 'Licencias 3CX', permiso: 'licencias3cx.ver' },
    ],
  },
  {
    id: 'marketing',
    nombre: 'Marketing',
    icono: 'send',
    secciones: [{ ruta: '/marketing/campanas', nombre: 'Campañas', icono: 'send', permiso: 'campanas.ver' }],
  },
  {
    id: 'reportes',
    nombre: 'Reportes',
    icono: 'chart',
    secciones: [
      { ruta: '/equipo', nombre: 'Equipo hoy', icono: 'eye', permiso: 'equipo.hoy' },
      { ruta: '/reportes/areas', nombre: 'Resumen por área', icono: 'users', permiso: 'reportes.casos' },
      { ruta: '/reportes/casos', nombre: 'Casos', icono: 'inbox', permiso: 'reportes.casos' },
      { ruta: '/reportes/horas', nombre: 'Horas del equipo', icono: 'clock', permiso: 'reportes.horas' },
      { ruta: '/reportes/bolsas', nombre: 'Bolsas de soporte', icono: 'money', permiso: 'reportes.bolsas' },
      { ruta: '/reportes/correo', nombre: 'Correo', icono: 'mail', permiso: 'reportes.correo' },
      { ruta: '/reportes/3cx', nombre: 'Llamadas 3CX', icono: 'phone', permiso: 'reportes.3cx' },
      { ruta: '/costos', nombre: 'Costos 3CX', icono: 'money', permiso: 'reportes.costos', modulo: 'TARIFICADOR' },
    ],
  },
  {
    id: 'admin',
    nombre: 'Administración',
    icono: 'sliders',
    abajo: true,
    secciones: [
      { ruta: '/administracion/usuarios', nombre: 'Usuarios', icono: 'users', permiso: 'admin.usuarios' },
      { ruta: '/administracion/roles', nombre: 'Roles y permisos', icono: 'lock', permiso: 'admin.usuarios' },
      { ruta: '/administracion/tipificaciones', nombre: 'Tipificaciones', icono: 'tag', permiso: 'admin.plantillas' },
      { ruta: '/administracion/buzones', nombre: 'Grupos', icono: 'users', permiso: 'admin.grupos' },
      { ruta: '/administracion/salud', nombre: 'Salud del correo', icono: 'status', permiso: 'admin.integraciones' },
      { ruta: '/administracion/almacenamiento', nombre: 'Almacenamiento', icono: 'archive', permiso: 'admin.licencia' },
      { ruta: '/administracion/vistas', nombre: 'Vistas de casos', icono: 'inbox', permiso: 'admin.vistas' },
      { ruta: '/administracion/plantillas', nombre: 'Plantillas y firmas', icono: 'note', permiso: 'admin.plantillas' },
      { ruta: '/administracion/automatizaciones', nombre: 'Automatizaciones', icono: 'clock', permiso: 'admin.automatizaciones' },
      { ruta: '/administracion/tarifas', nombre: 'Tarifas', icono: 'money', permiso: 'admin.integraciones' },
      { ruta: '/administracion/integracion', nombre: 'Integración 3CX', icono: 'link', permiso: 'admin.integraciones' },
      { ruta: '/administracion/licencia', nombre: 'Licencia', icono: 'lock', permiso: 'admin.licencia' },
    ],
  },
];

export type Permisos = { puede: (clave: string) => boolean; tieneModulo: (m: string) => boolean };

export const puedeVer = (s: Pick<Seccion, 'permiso' | 'modulo'>, p: Permisos) => (!s.permiso || p.puede(s.permiso)) && (!s.modulo || p.tieneModulo(s.modulo));

// Los modulos con lo que esta persona puede ver; los que quedan vacios desaparecen.
export const modulosVisibles = (p: Permisos) =>
  MODULOS.map((m) => ({ ...m, secciones: m.secciones.filter((s) => puedeVer(s, p)) })).filter((m) => m.secciones.length);

const coincide = (s: Seccion, pathname: string) =>
  pathname === s.ruta || pathname.startsWith(`${s.ruta}/`) || (s.tambien ?? []).some((t) => pathname.startsWith(t));

// La mas especifica gana: /licencias-3cx/renovaciones es "Renovaciones", no "Por vencer".
export const seccionDeRuta = (pathname: string, modulos: Modulo[] = MODULOS) => {
  let mejor: { modulo: Modulo; seccion: Seccion } | null = null;
  for (const m of modulos) for (const s of m.secciones) if (coincide(s, pathname) && (!mejor || s.ruta.length > mejor.seccion.ruta.length)) mejor = { modulo: m, seccion: s };
  return mejor;
};

// Lista plana (buscador y pruebas).
export type ItemMenu = Seccion & { grupo: ModuloId; nombreModulo: string };
export const MENU: ItemMenu[] = MODULOS.flatMap((m) => m.secciones.map((s) => ({ ...s, grupo: m.id, nombreModulo: m.nombre })));
